(function () {
  'use strict';

  angular.module('app').component('providerPage', providerDetailComponent());

  function providerDetailComponent() {
    return {
      bindings: {},
      controller: ProviderDetailCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/providers/provider-page.component.html',
    };
  }

  ProviderDetailCtrl.$inject = ['$location', '$routeParams', 'AbilityService', 'ProviderService'];

  function ProviderDetailCtrl($location, $routeParams, AbilityService, ProviderService) {
    var vm = this;

    vm.permissions = {
      canCreate: AbilityService.can('create_provider_accountadmin'),
    };

    var itemId = $routeParams.id;
    vm.mode = $routeParams.mode;

    vm.onSavedItem = onSavedItem;
    vm.onCanceledItem = onCanceledItem;

    // Initializers
    getItem();

    function getItem() {
      if (itemId) {
        // Edit
        vm.loadingItem = true;
        ProviderService.getProvider(itemId).then(function (data) {
          vm.item = data;

          vm.loadingItem = false;
        });
      } else {
        vm.item = {};
      }
    }

    function onSavedItem(item) {
      $location.path(`/providers/${item.id}`).search({ mode: 'edit' });
    }

    function onCanceledItem() {
      $location.path('/providers');
    }
  }
})();
